'use strict';

export default {}



// WEBPACK FOOTER //
// ./src/stores/getters.js